import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOfferId } from 'shared/selectors';

import { AVAILABLE_STATUS_LIST, TITLE_MAPPING } from './constants';
import { ErrorContent } from '../../components/ErrorContent';
import { LoadingContent } from '../../components/LoadingContent';
import { ESubscriptionLimitType } from '../../types/context';
import { useContext } from '../../utils/useContext';

export const FallbackModalContainer: React.FC = () => {
  const context = useContext();
  const offerId = useSelector(selectOfferId);

  const content = React.useMemo(() => {
    switch (context.status) {
      case 'loading': {
        return <LoadingContent />;
      }
      case 'failed': {
        const { checkContactsAccess } = context;

        return (
          <ErrorContent
            onRetry={() => checkContactsAccess({ offerId, limitType: ESubscriptionLimitType.PhoneNumber })}
          />
        );
      }
      default:
        return null;
    }
  }, [context, offerId]);

  if (!AVAILABLE_STATUS_LIST.includes(context.status)) {
    return null;
  }

  return (
    <ModalWindow
      open={context.open}
      onClose={context.onClose}
      title={TITLE_MAPPING[context.status]}
      width="100%"
      maxWidth={540}
      content={content}
      escape={false}
      size="M"
      fixed
    />
  );
};
